module.exports = __webpack_public_path__ + "img/hand.e853ff30.svg";